import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import bookingActions from 'actions/bookings/actions'
import SubmitButton from 'forms/shared/buttons/submit'
import Form from './form'

const formName = 'merchant-edit-proposal-form'

// if trying to re-edit a proposal while notification is still up.
// it'll redirect you back since {type === 'success' && handleClose()}
// i need to find a better way of checking
const EditProposal = ({
  id: proposalId,
  userId,
  options: { spaces: spaceOptions },
  details,
  fetchProposalOptions,
  fetchProposalDetails,
  editProposal,
  handleClose,
  notification: { type },
}) => {
  useEffect(() => {
    fetchProposalOptions({ id: userId })
    fetchProposalDetails({ id: proposalId })
  }, [])
  const { checkIn, checkOut } = details
  const schedule = [checkIn, checkOut]

  return <div className={`merchant-edit-proposal`}>
    <Form
      form={formName}
      onSubmit={values => editProposal({ ...values, proposalId })}
      initialValues={{ ...details, schedule }}
      spaceOptions={spaceOptions}
    />
    {type === 'success' && handleClose()}
    <div className="footer flex flex-col justify-center">
      <SubmitButton
        className="btn-primary py-3 px-4 whitespace-no-wrap rounded mx-auto"
        formName={formName}
      >
        SAVE AND SEND PROPOSAL
      </SubmitButton>
      <p className="text-sm text-primary-lightgray text-center mt-3">
        Note: Send this Proposal will also send a payment link to the client
      </p>
    </div>
  </div>
}

EditProposal.propTypes = {
  id: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  editProposal: PropTypes.func.isRequired,
  fetchProposalOptions: PropTypes.func.isRequired,
  fetchProposalDetails: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  details: PropTypes.object,
  options: PropTypes.object,
  notification: PropTypes.object,
}

const mapStateToProps = ({ bookings, auth, notification }) => ({
  userId: auth.user.id,
  details: bookings.proposalDetails,
  options: bookings.proposalOptions,
  notification,
});

const mapDispatchToProps = {
  fetchProposalOptions: bookingActions.fetchMerchantProposalOptions,
  fetchProposalDetails: bookingActions.fetchMerchantProposalDetails,
  editProposal: bookingActions.merchantEditProposal,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditProposal)
